"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeopleCard = void 0;
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const PeopleCard = (props) => {
    var _a;
    function handlePeopleChange(people) {
        // Keep in min/max range.
        let newPeople;
        if (isNaN(people)) {
            newPeople = 1;
        }
        else {
            newPeople = Math.min(Math.max(people, 1), 1000);
        }
        props.onBookingChange({
            people: newPeople,
        });
    }
    return (react_1.default.createElement(Card_1.default, { className: (_a = props.className) !== null && _a !== void 0 ? _a : "" },
        react_1.default.createElement(Card_1.default.Body, null,
            react_1.default.createElement(Form_1.default.Group, { controlId: "booking-people", className: "mb-0" },
                react_1.default.createElement(Form_1.default.Label, null, "Anzahl Personen (ungef\u00E4hr)"),
                react_1.default.createElement(Form_1.default.Control, { className: "", type: "number", value: props.booking.people.toString(), onChange: (e) => handlePeopleChange(parseInt(e.target.value)) })))));
};
exports.PeopleCard = PeopleCard;
